module.exports = __webpack_public_path__ + "img/TeodoroLocsinMessage25June2021.4a896673.jpg";